import { Fragment } from "react/jsx-runtime";
import Content from "../../../../components/Content/Content";
import ContentHeader from "../../../../components/ContentHeader/ContentHeader";
import ContentWrapper from "../../../../components/ContentWrapper/ContentWrapper";
import ContentFooter from "../../../../components/ContentFooter/ContentFooter";
import { useDispatch, useSelector } from "react-redux";
import { clearSelectedProject, nextStep, prevStep, setProjectSlides } from "../../../../redux/slices/projectDetailsSlice";
import { RootState } from "../../../../redux/store";
import { useEffect } from "react";
import { fetchProjectDetails } from "../../../../apiservice/Chatservice";
import SlideContentHeader from "../SlideContentHeader/SlideContentHeader";
import SlideContentWrapper from "../SlideContentWrapper/SlideContentWrapper";
import './WelcomeScreen.scss';
import { Images } from "../../../../assets/images";

export default function WelcomeScreen({ setLoading }: Readonly<{ setLoading: React.Dispatch<React.SetStateAction<boolean>> }>) {

    const dispatch = useDispatch();
    const currentUser = useSelector((state: RootState) => state.authVerification.currentUser);
    const { currentStep, selectedProject } = useSelector((state: RootState) => state.projectDetails);
    const handleNextStep = () => {
        dispatch(nextStep())
    }

    const handlePreviousStep = () => {
        currentStep === 1 ? dispatch(clearSelectedProject()) : dispatch(prevStep())
    }

    useEffect(() => {
        (async () => {
            setLoading(true);
            if (selectedProject?.p_id) {
                const response = await fetchProjectDetails(selectedProject.p_id);
                if (response?.slides) {
                    dispatch(setProjectSlides(response.slides));
                    setLoading(false);
                }
            }
        })()
    }, [selectedProject, dispatch])

    return (
        <ContentWrapper>
            <Fragment>
                <ContentHeader
                    title={"Project Details"}
                    subTitle={`Projects / ${selectedProject?.p_name}`}
                    handleBack={handlePreviousStep}
                />
                <Content>
                    <div className="welcome-content-wrapper">
                        <div className="project-info" style={{ background: `url("${selectedProject?.p_image_url ?? Images.Card}") no-repeat center / cover` }}>
                            <div className="project-details">
                                <div className={`project-title ${selectedProject?.p_image_url ? '' : 'dark'}`}>{selectedProject?.p_name}</div>
                                <div className={`project-desc ${selectedProject?.p_image_url ? '' : 'dark'}`} dangerouslySetInnerHTML={{ __html: selectedProject?.p_description ?? '' }}></div>
                            </div>
                        </div>
                        <div className="">
                            <SlideContentWrapper>
                                <SlideContentHeader>Welcome, {currentUser?.firstName ?? ''} {currentUser?.lastName ?? ''}!</SlideContentHeader>
                                <div className="slide-contents">
                                    Welcome aboard! You've officially joined the {selectedProject?.p_name}.
                                    You can now leverage AI tools to explore the project's documentation and assets seamlessly.
                                    Drive in and make the most of these resources to accelerate your journey with the project!
                                </div>
                            </SlideContentWrapper>
                        </div>
                    </div>
                </Content>
                <ContentFooter
                    primaryAction={{
                        label: "Next",
                        onClick: handleNextStep
                    }}
                />
            </Fragment>
        </ContentWrapper >
    )
}